import { api } from '../providers/base-api';

export async function exportDailyWorksReceiptRequest(params?: {
  dateBegin: string;
  dateEnd: string;
  user: number;
}): Promise<any> {
  const response = await api.get<any>(`/exportables/daily-work-receipt`, {
    params,
    responseType: 'blob',
  });

  return response;
}

export async function exportEpiReceiptRequest(
  employeeId: number,
): Promise<any> {
  const response = await api.get<any>(
    `/exportables/epi-receipt/${employeeId}`,
    { responseType: 'blob' },
  );

  return response;
}

export async function exportEpiHistoryReceiptRequest(
  employeeId: number,
): Promise<any> {
  const response = await api.get<any>(
    `/exportables/epi-receipt-history/${employeeId}`,
    { responseType: 'blob' },
  );

  return response;
}

export type SettleBankHoursRequestData = {
  userId?: number;
  username?: string;
  hours: number | undefined;
  minutes: number | undefined;
  totalValue: string;
  period?: string;
};

export async function settleBankHoursRequest(
  data: SettleBankHoursRequestData,
): Promise<any> {
  const response = await api.post<any>('/bank-hours/settle', data, {
    responseType: 'blob',
  });

  return response;
}

export async function bulkSettleBankHoursDataRequest(
  records: {
    username: string;
    bhAtual: string;
    totalValue: string;
    period?: string;
  }[],
): Promise<any> {
  const response = await api.post<any>(
    '/bank-hours/settle/bulk-data',
    { records },
    {
      responseType: 'blob',
    },
  );

  return response;
}
